// extracted by mini-css-extract-plugin
export default {"container":"ScaleCounter_container__qzbXU","number":"ScaleCounter_number__IyuFP","title":"ScaleCounter_title__1OXWT","subtitle":"ScaleCounter_subtitle__GiF1B"};